/* eslint-disable */
export const handleVoucherValidation = (inputFields) => {
    const formData = inputFields;
    const errors = {};
    if (!formData.amount) {
        errors.amount = 'Amount Date is required';
    }
    if (!formData.voucherDate) {
        errors.voucherDate = 'Vouchar Date is required';
    }

    if (!formData.billingGroupID) {
        errors.billingGroupID = 'Biiling Group is required';

    }




    // Return true if there are no errors
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};





